<template>
  <div class="monthly-view">
    <div class="header d-flex align-items-center p-0">
      <div v-for="(each, index) in days" :key="index" class="header-block">
        <div class="day">
          {{ isLangRtl ? formatDate(each, 'dddd') : getFormattedDay(each) }}
        </div>
      </div>
    </div>
    <div class="events d-flex align-items-center">
      <div v-for="(day, d_index) in days" :key="d_index" class="event-day">
        <div v-for="(b_r_range, b_r_index) in box_row" :key="b_r_index" class="event">
          <div v-if="getDate(d_index, b_r_index)">
            <div
              class="day-block"
              :class="[
                {
                  'present-day': isPresentDay(getDate(d_index, b_r_index)) ? true : false,
                },
              ]"
            >
              {{ getFormattedDate(d_index, b_r_index) }}
            </div>
            <div
              v-for="(event, index) in events.filter((e) =>
                findEvent(e.date, getDate(d_index, b_r_index))
              )"
              :key="index"
            >
              <div
                v-if="index < 3"
                class="block mt-1"
                :style="getBlockStyle(event)"
                @click.stop="$emit('eventClick', event)"
              >
                <div class="d-flex align-items-center">
                  <div class="name">{{ event.client }}</div>
                  <div class="event_id d-flex"><span>#</span>{{ event.trip_id }}</div>
                  <!-- <div class="dot"></div>
                  <div class="journey">
                    {{ event.number_of_trips }}
                  </div> -->
                </div>
              </div>
            </div>
            <div
              v-if="events.filter((e) => findEvent(e.date, getDate(d_index, b_r_index))).length > 3"
              class="more-link mt-1"
              v-b-toggle.sidebar-backdrop-event
              @click.stop="
                openMoreEvents(events.filter((e) => findEvent(e.date, getDate(d_index, b_r_index))))
              "
            >
              +
              {{ events.filter((e) => findEvent(e.date, getDate(d_index, b_r_index))).length - 3 }}
              more
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="more-event-sidebar">
      <b-sidebar
        id="sidebar-backdrop-event"
        backdrop-variant="transparent"
        bg-variant="white"
        backdrop
        :right="!isLangRtl"
        shadow
      >
        <div
          class="d-flex align-items-center justify-content-between pb-3 mb-3"
          style="border-bottom: 1px solid var(--color-14)"
          v-if="all_daily_events.length"
        >
          <div class="title-lg">
            {{ all_daily_events[0].date | moment('DD MMMM YYYY') }}
          </div>
          <div class="close" v-b-toggle.sidebar-backdrop-event>
            <img src="../../../assets/images/icons/cross-icon.svg" alt="cross-icon" />
          </div>
        </div>
        <div v-for="(event, index) in all_daily_events" :key="index">
          <div
            v-if="event.id"
            class="sidebar-event-block mb-2"
            :style="getBlockStyle(event)"
            @click.stop="$emit('eventClick', event)"
            v-b-toggle.sidebar-backdrop-event
          >
            <div class="side-border" :style="getBlockStyle(event)"></div>
            <div class="event_id">#{{ event.trip_id }}</div>
            <!-- <div class="dot"></div>
            <div class="journey">{{ event.number_of_trips }} Journeys</div> -->
            <div class="name">{{ event.client }}</div>
          </div>
        </div>
      </b-sidebar>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  props: ['selected_date', 'events', 'event_types'],
  emits: ['eventClick'],
  data() {
    return {
      days: [],
      dates: [],
      box_row: 0,
      start_index: 0,
      all_daily_events: [],
    }
  },
  methods: {
    findEvent(d, e) {
      return moment(d).isSame(moment(e), 'day')
    },
    isPresentDay(day) {
      return moment(day).isSame(moment(), 'day')
    },
    getBlockStyle(event) {
      const rec = this.event_types?.find((each) => each.value === event.type)
      return rec ? `background: ${rec.background};border: ${rec.border};` : null
    },
    openMoreEvents(data) {
      this.all_daily_events = data
    },
    getDates() {
      let daysInMonth = moment(this.selected_date).daysInMonth(),
        arrDays = []

      while (daysInMonth) {
        const current = moment(this.selected_date).date(daysInMonth)
        arrDays.push(current)
        daysInMonth--
      }

      arrDays.reverse()

      if (arrDays && arrDays.length) {
        this.start_index = this.days.findIndex(
          (each) => each.format('ddd') === arrDays[0].format('ddd')
        )

        for (let i = 0; i < this.start_index; i++) {
          arrDays.unshift(null)
        }

        this.box_row = Math.ceil(arrDays.length / 7)

        for (let i = arrDays.length; i < this.box_row * 7; i++) {
          arrDays.push(null)
        }

        this.dates = arrDays
      }
    },
    getRange() {
      const now = moment(this.selected_date)
      let temp = []

      for (let i = 0; i < 7; i++) {
        const day = now.clone().weekday(i)
        temp.push(day)
      }
      this.days = temp
      this.getDates()
    },
    getDate(d_index, b_r_index) {
      return this.dates[b_r_index * 7 + d_index]
    },
    getFormattedDate(d_index, b_r_index) {
      return moment(this.dates[b_r_index * 7 + d_index])
        .locale('en')
        .format('DD')
    },
    getFormattedDay(day) {
      return moment(day).locale('en').format('ddd')
    },
  },
  watch: {
    selected_date() {
      this.getRange()
    },
  },
  mounted() {
    this.getRange()
  },
  i18n: {
    messages: {
      en: require('@/services/i18n/locales/en/reservationOperations.json'),
      ar: require('@/services/i18n/locales/ar/reservationOperations.json'),
    },
  },
}
</script>

<style lang="scss" scoped>
.monthly-view {
  // min-width: 1056px;
  overflow: auto;
}
.header {
  .header-block {
    // flex: 1 1 0px;
    padding: 1rem;
    text-align: center;
    background: var(--color-11);
    color: var(--color-09);
    border-width: 0px 1px;
    border-style: solid;
    border-color: var(--color-01);

    .day {
      font-weight: 700;
      font-size: 14px;
      width: 166px;
    }
    .slots {
      font-weight: 400;
      font-size: 16px;
    }
    &:first-child {
      border-inline-start: 1px solid var(--color-15);
    }
    &:last-child {
      border-inline-end: 1px solid var(--color-15);
    }
  }
}
.events {
  .event-day {
    // flex: 1 1 0px;

    .event {
      height: 140px;
      width: 200px;
      padding: 0.25rem;
      border: 1px solid var(--color-15);
      border-top: 0px;
      border-inline-end: 0px;

      .day-block {
        height: 25px;
        width: 25px;
        background: var(--color-11);
        border-radius: 5px;
        text-align: center;
        font-weight: 700;
        font-size: 14px;
        color: var(--color-09);
      }

      .present-day {
        background: var(--color-09);
        color: var(--color-01);
      }

      .block {
        height: 25px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        padding: 0.15rem;
        border-radius: 4px;
        .event_id {
          font-size: 12px;
          color: var(--color-17);
          margin-inline-start: 0.25rem;
        }
        .dot {
          margin: 0rem 0.25rem;
          background: var(--color-17);
          border-radius: 50%;
          height: 5px;
          width: 5px;
        }

        .journey {
          color: var(--color-17);
          font-size: 12px;
        }

        .name {
          font-weight: 700;
          font-size: 12px;
          color: var(--color-17);
        }
      }

      .more-link {
        cursor: pointer;
        font-weight: 700;
        font-size: 10px;
        color: var(--color-09);
      }
    }

    &:last-child {
      .event {
        border-inline-end: 1px solid var(--color-15);
      }
    }
  }
}
.sidebar-event-block {
  padding: 0.5rem;
  border-radius: 8px;
  display: flex;
  align-items: center;
  cursor: pointer;
  .side-border {
    height: 50px;
    width: 1px;
    margin-inline-start: 0.25rem;
  }
  .event_id {
    font-size: 14px;
    color: var(--color-17);
    margin-inline-start: 1rem;
  }
  .dot {
    margin: 0rem 0.5rem;
    background: var(--color-17);
    border-radius: 50%;
    height: 5px;
    width: 5px;
  }

  .journey {
    color: var(--color-17);
    font-size: 12px;
  }

  .name {
    font-weight: 700;
    font-size: 16px;
    color: var(--color-17);
    margin-inline-start: 3rem;
  }
}

.more-event-sidebar {
  .close {
    cursor: pointer;
    img {
      height: 15px;
      width: 15px;
    }
  }
}
</style>

<style lang="scss">
.more-event-sidebar {
  .b-sidebar {
    height: 100vh;
    width: 500px;
    padding: 1.5rem;
    border-inline-start: 1px solid var(--color-09);
    box-shadow: 0px 12px 16px var(--color-38);
    background: var(--color-01);
  }
}
</style>
